import { getAwardTableCardData } from '_api/bbs/post'
import Vue from 'vue'
const CptName = 'ComAwardTableCard'
class AwardTableCards {
  #promise
  #resolve
  #article
  constructor (article) {
    this.cards = []
    this.#article = article
    this.#promise = new Promise(resolve => this.#resolve = resolve)
  }
  
  addCards (node) {
    if (node.dataset && node.dataset.award_table_id) {
      this.loadCard()
      let card = this.generateCardData(node)
      this.cards.push(card)
      return card
    }
    return node
  }

  loadCard () {
    if (!this.is_load_card) {
      this.dynImport()
      this.is_load_card = true
    }
  }

  dynImport () {
    import('./index.vue').then(cpt => {
      Vue.component(CptName, cpt.default)
      this.cards.forEach(item =>item.cpt = CptName)
    })
  }

  generateCardData (node) {
    let height = node.dataset.award_table_height || 80
    return {
      cpt: 'ComCardPlaceholder',
      data: {
        height,
        request: this.#promise,
        id: node.dataset.award_table_id,
        placeholder_style: {
          height: height + 'px',
          opacity: 0
        }
      }
    }
  }

  request () {
    if (this.cards.length == 0 || this.#article.options.preload) return
    this.#resolve(
      getAwardTableCardData({
        award_ids: this.cards.map(item => item.data.id).join(',')
      })
    )
  }
}
export default AwardTableCards